import { render, staticRenderFns } from "./transferisimlistesi.vue?vue&type=template&id=70ba5c25&scoped=true"
import script from "./transferisimlistesi.vue?vue&type=script&lang=js"
export * from "./transferisimlistesi.vue?vue&type=script&lang=js"
import style0 from "./transferisimlistesi.vue?vue&type=style&index=0&id=70ba5c25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba5c25",
  null
  
)

export default component.exports